module.exports = __webpack_public_path__ + "img/es.3a59673d.svg";